"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.popOverLayerId = exports.notificationLayerId = exports.modalLayerId = void 0;

var _react = _interopRequireDefault(require("react"));

var _NotificationsHandler = _interopRequireDefault(require("../notifications/NotificationsHandler"));

var modalLayerId = 'ModalLayer';
exports.modalLayerId = modalLayerId;
var notificationLayerId = 'NotificationLayer';
exports.notificationLayerId = notificationLayerId;
var popOverLayerId = 'PopOverLayer';
exports.popOverLayerId = popOverLayerId;

var Layers = function Layers() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    id: modalLayerId
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: notificationLayerId
  }, /*#__PURE__*/_react.default.createElement(_NotificationsHandler.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    id: popOverLayerId
  }));
};

Layers.displayName = 'Layers';
var _default = Layers;
exports.default = _default;